import { h } from 'preact';

import { getLabel } from '../../../../labels/labelling-service';
import Cta from '../../../components/2-atoms/cta/cta';

export const renderCta = ({ isUserLogged, userPreferences, ctaAppend, intcmpCta, ctaDefaultUrl, ctaDefaultLabel }) => {
  if (isUserLogged && userPreferences.length > 0) {
    const preferenceName = userPreferences[0].name;
    const ctaLabel = getLabel('parsely.common.show.preference.news').replace('%s', preferenceName);
    return (
      <div className="o-distributed--right-t">
        <Cta
          modifiers={['secondary']}
          href={userPreferences[0].config.linkCta}
          append={ctaAppend}
          intcmpCta={intcmpCta}
        >
          {ctaLabel}
        </Cta>
      </div>
    );
  }
  if (ctaDefaultUrl) {
    return (
      <div className="o-distributed--right-t">
        <Cta modifiers={['secondary']} href={ctaDefaultUrl} append={ctaAppend} intcmpCta={intcmpCta}>
          {ctaDefaultLabel}
        </Cta>
      </div>
    );
  }
  return null;
};
